import React from 'react';
import {render} from 'react-dom';
import * as serviceWorker from './serviceWorker';
import FullApp from './FullApp';
import 'semantic-ui-css/semantic.min.css';

render(<FullApp/>, document.getElementById('root'));
serviceWorker.unregister();
